<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="luckyWinnerSubscribePopupVisibility"
    [style]="{ width:'550px', height: '500px' }" [contentStyle]="{ 'border-bottom-right-radius': '20px', 'border-bottom-left-radius': '20px',  'overflow': 'visible' }" position="center" [closable]="true" (onHide)="handlePopupClose()">

    <div class="subscribe-promo-main">
        <div class="subscribe-promo-container">
            <div class="subscribe-promo-box subscribe-left-image-box">
                <img title="NutriGenic Get Started" decoding="async" src="assets/images/Dish-left-cut.png">
            </div>
            <div class="subscribe-promo-box subscribe-promo-text-box">

                <div class="promo-text">
                    <h1>Win a Year <br *ngIf="isDesktop">Of FREE FOOD<small>*</small></h1>
                
                    <h2>Yes! 365 Days. Totally Free.</h2>

                    <form id="subscribe-promo-form" [formGroup]="promoForm" (ngSubmit)="subscribePromo()" >
                        <div class="subscribe-promo-form-field">
                            
                            <input formControlName="fullName" placeholder="Full name"/>
                            <div *ngIf="promoForm.get('fullName')?.invalid && promoForm.get('fullName')?.touched" class="validation-error">
                                Full name is required.
                            </div>
                        </div>

                        <div class="subscribe-promo-form-field">
                            
                            <input formControlName="email" placeholder="Email"/>
                            <div *ngIf="promoForm.get('email')?.invalid && promoForm.get('email')?.touched" class="validation-error">
                                Enter a valid email.
                            </div>
                        </div>
                        <div>
                            <button type="submit">Get Started</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="subscribe-promo-box subscribe-right-image-box">
                <img alt="NutriGenic Get Started" title="NutriGenic Get Started" decoding="async" src="assets/images/Dish-right-cut.png">
            </div>
        </div>
        <a href="/terms" class="terms-and-conditions">*Terms And Conditions Apply</a>
    </div>
    
</p-dialog>


<!-- Second Popup -->


<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="luckyWinnerOrderNowPopupVisibility"
    [style]="{ width:'550px' }" [contentStyle]="{ 'border-bottom-right-radius': '20px', 'border-bottom-left-radius': '20px', 'overflow-x': 'hidden' }" position="center" [closable]="true" (onHide)="handlePopupClose()">


    <div>
        <div class="promo-box">
            <div class="lucky-winner-order-now-image-box">
                <img alt="NutriGenic Get Started"
                        title="NutriGenic Get Started" decoding="async"
                        src="assets/images/promo-image-user-phone.png">
            </div>
            <div class="promo-text">
                <h1>Make the Smart Switch</h1>
            </div>
            <div class="promo-text">
                <h2>
                    Order now with code <span>SUMMER25</span><br> 
                    &amp; Get 25% Off Your Plan. <br> 
                    One Lucky Customer <span>Will Get a Year of FREE Food</span>
                </h2>
            </div>
            <div class="web-center" style="margin-top: 20px !important;">
                <app-orange-button text="Order Now"  (action)="goToPlan()" />
            </div>
        </div>
    </div>

</p-dialog>